export default __webpack_public_path__ + "static/media/ForeB.a13a371c.jpg";